import { FLOOR_PLANS_LAYOUT } from '../constants';

export const FloorDetail = ({ selectedBuilding, selectedSegment }) => {
  const { totalApartments, totalElevators } =
    FLOOR_PLANS_LAYOUT[selectedBuilding];
  return (
    <div className="floor-detail-card">
      <div className="card-content">
        <div className="card-header">
          <p className="title">Mặt bằng {selectedBuilding.toUpperCase()}</p>
          {/* <p className="description">Tầng 6-22</p> */}
        </div>
        <div className="card-body">
          <div className="body-item">
            <span className="title">Số căn hộ</span>
            <span className="number">{totalApartments}</span>
          </div>
          <div className="body-item">
            <span className="title">Số thang máy</span>
            <span className="number">{totalElevators}</span>
          </div>
          {/* <div
            className="map"
            style={{
              transform: selectedBuilding === 'vic-1' && 'scale(1, -1)',
            }}
          >
            <img
              src={mini}
              alt={`Mặt bằng toà nhà của ${selectedBuilding}-${selectedSegment}`}
            />
          </div> */}
        </div>
      </div>
    </div>
  );
};
